<script>
import VueApexCharts from "vue-apexcharts";
import _ from "lodash";

export default {
  name: "DomainCharts" ,
  components: {VueApexCharts},
  props: {
    endpoints: {
      type: Array,
      required: true
    }
  },
  computed: {
    domains: function () {
      let endpointGroupedByDomain = _.groupBy(this.endpoints, 'domain')
      return Object.keys(endpointGroupedByDomain).map(domain => {
        return {
          domain: domain,
          total: endpointGroupedByDomain[domain].length,
        }
      })
    },
    chartSeries: function () {
      return this.domains.map(domain => domain.total)
    },
    chartOptions: function () {
      return {
        dataLabels: {
          enabled: false
        },
        chart: {
          width: 900,
          type: 'pie',
        },
        labels: this.domains.map(domain => domain.domain.substring(0, 20))
      }
    }
  }
}
</script>

<template>
  <vx-card title="Dominios">
    <vue-apex-charts
        v-if="chartSeries.length > 0"
        type="pie"
        id="domain-chart"
        height="800"
        :options="chartOptions"
        :series="chartSeries"
    />
  </vx-card>
</template>

<style scoped>

</style>